module.exports = __webpack_public_path__ + "img/PDFVector.8dc569ef.svg";